import LoginForm from "./signinPage";
import SignUpForm from "./registerPage";
import Testimonial from "../Global/Testimonial";
import { ChevronRight } from "@mui/icons-material";
import { LoginUIStateProvider } from "../../context/AuthContext";
import { useContext } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Box } from "@mui/material";

//
const AuthPage = () => {
  return (
    <LoginUIStateProvider>
      <section className="auth">
        <div className="container flex gap-3">
          <section className="left-panel w-75 shadow-1 p-4">
            <LoginForm />
            <SignUpForm />
          </section>
          <section className="w-50 right-panel pl-5">
            <div className="">
              <div className="speciality-highlight ">
                <h2 className="section-title text-primary text-align-left">
                  Here is why we are different with others:
                </h2>
                <p className="speciality-text">
                  Whether you're starting out or scalling up, grow faster with
                  <strong>Us</strong>. Take a look at some of the best benefits
                  that you will get.
                </p>
                <div className="speciality-content">
                  <ul className="speciality-list column">
                    <li className="speciality-item">
                      <div className="speciality-item-icon">
                        <ChevronRight />
                      </div>
                      <p className="speciality-item-text">
                        Automate your sales, marketing, and service in one
                        platform. Avoid data leakes and enable consistent
                        messaging.
                      </p>
                    </li>
                    <li className="speciality-item">
                      <div className="speciality-item-icon">
                        <ChevronRight />
                      </div>
                      <p className="speciality-item-text">
                        Market like the most successful companies in the world
                        with Agile CRMS's marketing automation software.
                      </p>
                    </li>
                    <li className="speciality-item">
                      <div className="speciality-item-icon">
                        <ChevronRight />
                      </div>
                      <p className="speciality-item-text">
                        Great customer support seperates decent companies from
                        excellent companies. A positive customer support
                        experience is a crucially important piece of the
                        customer journey.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="auth-testimonials ">
              <h2 className="section-title text-primary">
                What Our Customers Say
              </h2>
              <Testimonial />
            </div>
          </section>
          <section className="auth-error">
            {/* toast container to display toast */}
            <Box
              color={"InfoText"}
              marginTop={"4rem"}
              sx={{
                "$ .toast-container": {
                  width: "10rem",
                  bgcolor: "grey",
                },
              }}
            >
              <ToastContainer
                className={"toast-container"}
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
              />
            </Box>
          </section>
        </div>
      </section>
    </LoginUIStateProvider>
  );
};
export default AuthPage;

